var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divideContaner"},[_c('div',{staticClass:"divideImage"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"draggable":"false","src":require("./divide-vertical.png")}})])])}]
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/split-panel/divide-vertical.vue